'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of patient resources
 */ const PatientResources = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M62.1803 17.9761L26.8827 24.501C24.3463 24.9698 22.6628 27.4155 23.1318 29.953L32.2894 79.4925C32.7584 82.03 35.205 83.7123 37.7415 83.2434L73.039 76.7185C75.5765 76.2494 77.2588 73.8029 76.7899 71.2664L67.6323 21.727C67.1633 19.1895 64.7167 17.5072 62.1803 17.9761Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M72.9027 27.0918H37.0559C34.4799 27.0918 32.3828 29.1926 32.3828 31.7753V82.1978C32.3828 84.7805 34.4799 86.8813 37.0559 86.8813H72.9027C75.4797 86.8813 77.5758 84.7795 77.5758 82.1978V31.7753C77.5758 29.1926 75.4787 27.0918 72.9027 27.0918Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "55.4492",
                y: "40.2324",
                width: "16",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "38.4492",
                y: "64.2324",
                width: "33",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "39",
                y: "52",
                width: "32",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "38.4492",
                y: "77.2324",
                width: "33",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "55.4492",
                y: "34.2324",
                width: "16",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "38.4492",
                y: "58.2324",
                width: "33",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "55.4492",
                y: "46.2324",
                width: "16",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "38.4492",
                y: "70.2324",
                width: "33",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M41.2109 37.2819C41.2109 39.0949 42.6961 40.5638 44.5263 40.5638C46.3566 40.5638 47.8417 39.0949 47.8417 37.2819C47.8417 35.4689 46.3578 34 44.5263 34C42.6948 34 41.2109 35.4689 41.2109 37.2819Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M47.3691 41.4355C46.5576 41.985 45.5792 42.307 44.5263 42.307C43.4734 42.307 42.4937 41.985 41.6822 41.4355C40.082 42.3283 39 44.0296 39 45.9849V46.6665C39 47.4033 39.6004 47.9994 40.3399 47.9994H48.7115C49.4509 47.9994 50.0513 47.4021 50.0513 46.6665V45.9849C50.0513 44.0296 48.9693 42.3283 47.3691 41.4355Z",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.PatientResources = PatientResources;
//# sourceMappingURL=PatientResources.cjs.map
